<app-key-value [icon]="icon"
               [label]="label | translate">
  @if (imageSrc) {
    <div slot="custom-value" class="d-flex gap-2 align-items-center">
      <img [src]="imageSrc"
           width="100px"
           height="100px"
           alt="{{ urlLabel || (label | translate) }}"
           class="document-image">
      @if (languageLabel) {
        <ix-pill variant="neutral" [attr.title]="language">{{ languageLabel }}</ix-pill>
      }
    </div>
  } @else if (language) {
    <div slot="custom-value" class="d-flex gap-2 align-items-center">
      <ix-link-button [url]="url"
                      target="_blank">
        {{ urlLabel }}
      </ix-link-button>
      <ix-pill variant="neutral" [attr.title]="language">{{ languageLabel }}</ix-pill>
    </div>
  } @else {
    <ix-link-button slot="custom-value"
                    [url]="url"
                    target="_blank">
      {{ urlLabel }}
    </ix-link-button>
  }
</app-key-value>
